import React, { useState, useEffect, useRef } from "react";
import { TextField, SortMenu } from "@ann/web-components";
import {
  FiltersContainer,
  FiltersLeftContent,
  FiltersRightContent,
} from "./Filters.styled";
import { useDebounce } from "../../../../../../../hooks";

const Filters = ({
  onSortChange,
  onOrderChange,
  selectedSortOption = "created_at",
  orderDirection = "desc",
  onSearchChange,
  loading = false,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const debouncedSearchValue = useDebounce(searchValue);
  const onSearchChangeRef = useRef(onSearchChange);

  useEffect(() => {
    onSearchChangeRef.current = onSearchChange;
  }, [onSearchChange]);

  useEffect(() => {
    onSearchChangeRef.current?.(debouncedSearchValue);
  }, [debouncedSearchValue]);

  const handleSearchChange = (value) => {
    setSearchValue(value);
  };

  return (
    <FiltersContainer>
      <FiltersLeftContent>
        <TextField
          iconLeft="search"
          onChange={handleSearchChange}
          size="small"
          placeholder="Search"
          value={searchValue}
          disabled={loading}
        />
      </FiltersLeftContent>

      <FiltersRightContent>
        <SortMenu
          minWidth="200px"
          onChange={onSortChange || (() => {})}
          order={orderDirection.toLowerCase()}
          onOrderChange={onOrderChange || (() => {})}
          options={[
            {
              icon: 'clock',
              id: 'created_at',
              label: 'Most Recent'
            },
            {
              icon: 'sortByAlpha',
              id: 'department_name',
              label: 'Name (A-Z)'
            },
            {
              icon: 'person',
              id: 'user_count',
              label: 'User Count'
            },
            {
              icon: 'label',
              id: 'status',
              label: 'Status'
            }
          ]}
          selected={selectedSortOption}
          size="medium"
          title="SORT BY"
          width="240px"
          disabled={loading}
        />
      </FiltersRightContent>
    </FiltersContainer>
  );
};

export default Filters;

